// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37Jsj","rootNoMargin":"styles_rootNoMargin__365eZ"};